import Error404 from "./error404";
import Login from "./Login/Login";
import Dashboard from "./Dashboard";
import Country from "./Income/country";
import TypeConcept from "./Administration/TypeConcept";
import CollectingEntity from "./Entity/CollectingEntity";
import ChannelTransaction from "./Channel/ChannelTransaction";
import Branch from "./Entity/Branch";
import Channel from "./Channel/channel";
import Account from "./Entity/account";
import LimitAmountEntity from "./Entity/LimitAmountEntity";
import ChannelEntityPayment from "./Channel/ChannelEntityPayment";
import Monitor from "./Income/monitor";
import SendIncome from "./Income/sendIncome";
import ClientSap from "./Income/ClientSap";
import Summary from "./Income/conciliation";
import Template from "./Administration/template";
import TemplateAssign from "./Administration/templateAssign";
import ConciliationMonitor from "./ConciliationMonitor/conciliationMonitor";
import History from "./Income/History";

import Message from "./Administration/Message";
import ConnectionSftp from "./Administration/ConnectionSftp";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Error404,
  Login,
  Dashboard,
  Country,
  ChannelTransaction,
  TypeConcept,
  CollectingEntity,
  Branch,
  Channel,
  Account,
  LimitAmountEntity,
  ChannelEntityPayment,
  Message,
  Monitor,
  SendIncome,
  ClientSap,
  Summary,
  ConnectionSftp,
  Template,
  TemplateAssign,
  ConciliationMonitor,
  History
};
